module.exports = __webpack_public_path__ + "static/media/galeryAbout3.ef43a75f.jpg";